// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
import { RevenuePlanMessageType, RevenueCommissionType } from "../../../../Utils/Enums/Constants.js"
import { DirectMessageCode } from "../../../../Utils/DirectMessages/DirectMessageCodes.ts"
import { DirectMessageBase } from "../../../../Utils/DirectMessages/DirectMessageBase.ts"

export let RevenuePlanMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_COMMISSION_PLAN_MESSAGE)

    this.RevenuePlanMessageType = RevenuePlanMessageType.Comission;

    this.Id;

    this.Name;
    this.Description;

    this.CommisionForTransfer;
    this.CounterAccountID;
    this.TransferCommisionType = RevenueCommissionType.None;
    this.WithdrawalCommisionType = RevenueCommissionType.None;

    this.TransferPercentage;
    this.WithdrawalPercentage;
    this.TransferFixedFee;
    this.WithdrawalFixedFee;
    this.TransferMinFee;
    this.WithdrawalMinFee;
    this.TransferMaxFee;
    this.WithdrawalMaxFee;

    this.TransferCurrencyId;
    this.WithdrawalCurrencyId;
    this.TransferAccountId;
    this.WithdrawalAccountId;

    this.CommissionItems = new Array();
    this.SpreadItems = new Array();
}
RevenuePlanMessage.prototype = Object.create(DirectMessageBase.prototype)

//#region RevenueSpreadItem
export let RevenueSpreadItem = function ()
{
    this.Id;
    this.InstrumentTypeId;
    this.InstrumentId;
    this.Spread;
    this.BidShift;
    this.AskShift;
    this.SpreadMode;
    this.SpreadMeasure; //SpreadMeasureMode
}

Object.defineProperty(RevenueSpreadItem.prototype, "TypeId",
    {
        get: function () { return this.InstrumentTypeId; }
    });

//#endregion RevenueSpreadItem